import { api } from '../api';

export const getExamProcedureFile = async (name: string): Promise<string> => {
  const { data } = await api.get<string>(
    `/patients/examProcedure/file/${name}`,
  );

  return data;
};
